<template>
  <div>
    <v-select v-model="takenCollegeCourses" :items="collegeCreditOptions" label="Have you taken any college courses?" :rules="[v => !!v || 'Required']"></v-select>
    <v-list>
      <v-list-item v-for="(college, index) in selectedColleges" :key="'college-'+index" style="flex-wrap:wrap">
        <v-list-item-content :style="collegeNameStyle">
          <v-list-item-title>{{ college.name }}</v-list-item-title>
          <v-list-item-subtitle>{{ college.city }}, {{ college.state }}</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-content style="min-width:100px;flex:2 1">
          <v-text-field v-model="selectedColleges[index].startDate" label="Start Date" :rules="[v => !!v || 'Required']" style="max-width:90%"></v-text-field>
        </v-list-item-content>
        <v-list-item-content style="flex: 2 1">
          <v-text-field v-model="selectedColleges[index].endDate" label="End Date" :rules="[v => !!v || 'Required']" style="max-width:90%"></v-text-field>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon color="red" @click="selectedColleges.splice(index, 1)">
            <v-icon>fal fa-times-circle</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-dialog v-model="collegeSearchActive" width="600" v-if="takenCollegeCourses === 'Dual' || takenCollegeCourses === 'Transfer'">
      <template v-slot:activator="{ on }">
          <v-btn v-on="on">Add College</v-btn>
      </template>
      <v-card>
        <v-card-title>Add a college</v-card-title>
        <v-tabs v-model="collegeSearchTab">
          <v-tab>Search</v-tab>
          <v-tab>Enter manually</v-tab>
        </v-tabs>
        <v-tabs-items v-model="collegeSearchTab">
          <v-tab-item>
            <v-card>
              <v-card-text>
                <p>Search our list of colleges.</p>
                <v-autocomplete v-model="selectedCollege" :search-input.sync="collegeSearch" :items="collegeSearchResults" return-object item-text="search" item-value="value" :filter="() => { return true }">
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>No matching college found</v-list-item-title>
                        <v-list-item-subtitle>Check your spelling or click the "Enter Manually" option above to enter the college details.</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title>{{ item.name }}</v-list-item-title>
                      <v-list-item-subtitle>{{ item.city }}, {{ item.state }} {{ item.nation }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card>
              <v-card-text>
                <p>Please enter the college name, city, and state.</p>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="manualCollegeName" label="Name"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="manualCollegeCity" label="City"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select v-model="manualCollegeState" label="State" :items="states"></v-select>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <v-card-actions>
          <v-btn @click="collegeSearchActive = false; collegeSearchTab = 0;">Cancel</v-btn>
          <v-btn v-if="collegeSearchTab === 1" @click="addManualCollege()" :disabled="manualCollegeName === '' || manualCollegeCity === '' || manualCollegeState === ''">Add College</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { ref, computed, onMounted, watch } from '@vue/composition-api'
export default {
  setup (props, { root, emit }) {
    const takenCollegeCourses = ref('')
    const selectedColleges = ref([])
    const collegeCreditOptions = computed(() => {
      let arr = [
        { value: 'None', text: 'I have not taken any college courses' },
        { value: 'Dual', text: 'I have taken some courses while enrolled in high school (dual-enrollment)' },
        { value: 'Transfer', text: 'I have been enrolled in a college (transferring)' }
      ]
      if (selectedColleges.value.length > 0) {
        arr[0].disabled = true
      }
      return arr
    })

    const collegeList = ref([])
    const collegeSearchActive = ref(false)
    const searchForCollege = ref(true)
    const collegeSearchTab = ref(0)
    const collegeSearch = ref('')
    const collegeSearchResults = ref([])
    const selectedCollege = ref({})
    const manualCollegeName = ref('')
    const manualCollegeCity = ref('')
    const manualCollegeState = ref('')
    const states = ref([])

    onMounted(() => {
      const service = root.$feathers.service('forms/select-options')
      service.find({ query: { name: 'State/Province/Territory' } }).then(({ data }) => {
        if (data.length > 0) {
          service.get(data[0].value).then(({ options }) => { states.value = options })
        }
      })
    })

    watch(collegeSearch, (val) => {
      if (val != null && val !== '') {
        let query = { search: { $like: '%' + val.replace(/ /g, '%') + '%' }, $limit: 20 }
        root.$feathers.service('warehouse/colleges').find({ query }).then(({ data }) => { collegeSearchResults.value = data })
      }
    })
    watch(selectedCollege, (val) => {
      if (val != null && typeof (val) === 'object' && 'value' in val) {
        selectedColleges.value.push({ ...val })
        collegeSearchActive.value = false
        collegeSearch.value = null
        selectedCollege.value = null
        manualCollegeName.value = ''
        manualCollegeCity.value = ''
        manualCollegeState.value = ''
      }
    })

    function addManualCollege () {
      if (manualCollegeName.value !== '' && manualCollegeCity.value !== '' && manualCollegeState.value !== '') {
        selectedColleges.value.push({ name: manualCollegeName.value, city: manualCollegeCity.value, state: manualCollegeState.value })
        collegeSearchActive.value = false
        collegeSearch.value = null
        selectedCollege.value = null
        manualCollegeName.value = ''
        manualCollegeCity.value = ''
        manualCollegeState.value = ''
      }
    }

    const collegeNameStyle = computed(() => {
      switch (root.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'min-width:100%'
        default:
          return 'flex: 4 1'
      }
    })

    watch([takenCollegeCourses, selectedColleges], () => {
      emit('change', { studentType: takenCollegeCourses.value, colleges: selectedColleges.value })
    })

    return {
      takenCollegeCourses,
      selectedColleges,
      collegeCreditOptions,
      collegeList,
      collegeSearchActive,
      searchForCollege,
      collegeSearchTab,
      collegeSearch,
      collegeSearchResults,
      selectedCollege,
      manualCollegeName,
      manualCollegeCity,
      manualCollegeState,
      states,
      addManualCollege,
      collegeNameStyle
    }
  }
}
</script>
